import * as css from "./Carousel.module.css";

export interface ISlidePosition {
    left: number;
    right: number;
    index: number;
    width: number;
}

export enum CarouselAnimationAppearance {
    Standard,
    Fade,
}

export const positionX = (pos?: number) => {
    if (!pos) {
        return 0;
    }

    return pos > 0 ? pos * -1 : pos;
};

export const isAllVisible = (slide: ISlidePosition, containerWidth: number) =>
    slide && slide.left >= 0 && slide.left >= 0 && slide.right <= containerWidth;

export const applyTransform = (value: number, container: HTMLElement | null) => {
    if (container) {
        container.style.transform = `translate3d(${value}px, 0, 0)`;
    }
};

export const toggleAnimation = (container: HTMLElement | null, enable: boolean) =>
    container &&
    (enable ? container.classList.remove(css.noAnimate) : container.classList.add(css.noAnimate));

export const addClassListArray = (element: HTMLElement | null, className: string) =>
    element && className && element.classList.add(className);

export const removeClassListArray = (element: HTMLElement | null, className: string) =>
    element && className && element.classList.remove(className);

export const visibleIndexes = (active: ISlidePosition[]) => active.map((a) => a.index);

export const scrollerBoundX = (accumulatedWidth: number, containerWidth: number) => {
    if (accumulatedWidth > containerWidth) {
        return [(accumulatedWidth - containerWidth) * -1, 0];
    }

    return [0, 0];
};

export const lazyLoadingThresholdMin = (activeIndex: number, lazyLoadingThreshold?: number) =>
    lazyLoadingThreshold ? activeIndex - lazyLoadingThreshold : 0;

export const lazyLoadingThresholdMax = (activeIndex: number, lazyLoadingThreshold?: number) =>
    lazyLoadingThreshold ? activeIndex + lazyLoadingThreshold : 0;
